export default "__VITE_ASSET__yQ5Mw_tp$C5jgqb_o_VSHg__ 480w, __VITE_ASSET__N8THQCiGQAK_wQXofhkUjg__ 848w";